<template>
  <div class="secondPage" style="background-image: linear-gradient(#fff, #fbfbfd);position: relative" :style="{height:screenHeight}">
    <span class="title text-center" :class="activeShow===2?'animate__animated animate__bounceInUp':''">365跑腿 您的私人配送助理</span>
    <span class="subtitle text-center margin-bottom-15" :class="activeShow===2?'animate__animated animate__bounceInUp':''">不一样的同城配，不一样的高品位</span>
    <div style="width:94%;margin-left:2.3%;float:left;overflow: hidden;border-radius:10px;box-shadow: 2px 1px 10px #ddd;" :style="{maxWidth: screenWidth}">
      <van-swipe class="my-swipe" :autoplay="4000" indicator-color="#2d8cf0" @change="onChange" ref="swipe" style="width:100%;float:left;padding-bottom:20px;">
        <van-swipe-item v-for="(item,index) in cardList" :key="index">
          <img :src="item.thumb" style="width:100%;float:left;" class="secondImg">
          <span class="card_span text-bold text-18 margin-top-20" style="letter-spacing: 5px;">{{item.title}}</span>
          <span class="card_span text-14 card_span2">{{item.desc}}</span>
          <img :src="item.imgList" style="width:100%;float:left;">
        </van-swipe-item>
        <template #indicator>
          <div class="custom-indicator"></div>
        </template>
      </van-swipe>
    </div>
    <div class="indicat">
      <ul>
        <li v-for="(item,index) in cardList" :key="index" :class="index===activeIndex?'active':''" @click="changeSwipe(index)"></li>
      </ul>
    </div>
    <div class="width100 float-left">
      <span class="orangeButton" @click="this.$goToUserClient">
        立即下单
      </span>
    </div>
    <div class="width100 text-center">
      <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/down-arrow-grey.png" class="downButton" @click="moveSectionDown">
    </div>
  </div>
</template>

<script>
export default {
  name: 'secondPage',
  data(){
    return {
      screenHeight:0,
      screenWidth:0,
      activeIndex:0,
      cardList:[
        {
          title:"生活速递 解救健忘",
          desc:"自从有了365，从此同城零距离",
          thumb:"https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/card_bg1.jpg",
          imgList:"https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/tags1.jpg"
        },
        {
          title:"紧急递送 省心省钱",
          desc:"同城配送，优质快捷放首位",
          thumb:"https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/card_bg2.jpg",
          imgList:"https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/tags2"
        },
        {
          title:"美食速递",
          desc:"更快、更鲜、更靠谱",
          thumb:"https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/card_bg3.jpg",
          imgList:"https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/tags3.jpg"
        },
        {
          title:"商务速递",
          desc:"同城配送全方位，优质生活零距离",
          thumb:"https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/card_bg4.jpg",
          imgList:"https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/tags4.jpg"
        },
        {
          title:"同城帮帮",
          desc:"急你所急，帮你所需",
          thumb:"https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/card_bg5.jpg",
          imgList:"https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/tags5.jpg"
        }
      ]
    }
  },
  props: {
    activeShow: Number
  },
  mounted(){

  },
  created(){
    this.screenHeight = document.documentElement.clientHeight+'px';
    this.screenWidth = document.documentElement.clientWidth+'px';
  },
  methods:{
    // 翻页方法 子传父
    moveSectionDown(){
      this.$emit('moveSectionDown');
    },
    // 焦点图切换回调
    onChange(index) {
      this.activeIndex = index;
    },
    // 切换焦点图
    changeSwipe(index){
      this.$refs.swipe.swipeTo(index);
    }
  }
}
</script>
<style>
  /*iphone5样式适配*/
  @media (max-height: 569px){
    .orangeButton{margin-top:10px !important;padding:5px 0 !important;}
    .secondPage .indicat{margin-top:10px !important;}
    .indicat ul li{width:10px !important;height:10px !important;}
    .secondPage .van-swipe{padding-bottom:10px !important;}
    .secondPage .title{margin-top:15% !important;}
  }
  /*iphoneX样式适配*/
  @media (min-height: 737px) and (max-height: 820px){
    .subtitle{margin-bottom: 30px !important;}
    .orangeButton{margin-top:15% !important;margin-bottom:10%;}
    .secondPage .van-swipe{padding-bottom:30px !important;}
  }
</style>
